/**
 * @module EmptyNotifications
 * @package @geenius/notifications-solidjs-css
 * @description Renders the empty-state used when there are no notifications to
 * display in the SolidJS vanilla CSS variant.
 */

import { FadeIn } from '@geenius/motion/solidjs-css'
import type { JSX } from 'solid-js'
import { cx } from '../lib/cx'
import { createNotificationCopy } from '../lib/notificationCopy'

/**
 * Props for the SolidJS CSS empty-state component.
 */
export interface EmptyNotificationsProps {
  class?: string
}

/**
 * Renders the empty notification state.
 *
 * @param props Optional style override for the empty-state container.
 * @returns The empty-state markup.
 */
export function EmptyNotifications(props: EmptyNotificationsProps): JSX.Element {
  const { t } = createNotificationCopy()

  return (
    <FadeIn class={cx('notifications__empty', props.class)}>
      <span class={cx('notifications__empty-icon')}>🔔</span>
      <div class={cx('notifications__empty-title')}>
        {t('notifications.empty.title')}
      </div>
      <div class={cx('notifications__empty-text')}>
        {t('notifications.empty.description')}
      </div>
    </FadeIn>
  )
}
